export const REGISTER = 'REGISTER';
export const REGISTER_CLEAR = 'REGISTER_CLEAR';
export const MINOR_FLOW = 'MINOR_FLOW';
